



  <span class="loader" *ngIf="!(isGlobalLoading$ | async)"></span>
